<template>
    <div>
        <BaseCard>
            <template #card-body>
                <template v-if="statsData.length">
                    <div>
                        <slot name="header-caption" />
                        <pie-chart :data="statsData" />
                    </div>
                </template>

                <template v-else>
                    <EmptyPage 
                        state="empty_custom" 
                        icon-name="report" 
                        type="data"
                        title=" No data available." 
                    />
                </template>
            </template>
        </BaseCard>
    </div>
</template>

<script>
import { BaseCard, EmptyPage } from "@/components/ui/index";

export default {
    name: "PieChartReport",

    components: {
        BaseCard,
        EmptyPage,
    },

    props: {
        label: {
            type: String,
            default: "",
            
        },
        statsData: {
            type: Array,
            default: () => [],
        },
        field: {
            type: String,
            default: "",
            validator: (value) => {
                return ["client", "project", "invoice"].includes(value);
            },
        },
        iconName: {
            type: String,
            default: "report",
        },
    },
};
</script>

<style lang="scss" scoped>
    .tag {
        border-radius: 50%;
        height: 7px;
        width: 7px;
        padding: 0.1rem;

        &--cornsilk {
           background:  rgb(210, 105, 30)!important;
        }
   
        &--purple {
            background: #6b21a8 !important;
        }
    
        &--pink {
            background: #DA7DA0 !important;
        }
    
        &--red {
            background: rgb(144, 22, 69) !important;
        }
        
        &--green {
            background: #228d2d !important;
        }
    
        &--blue {
            background: #1e40af !important;
        }
    
        &--yellow {
            background: #e8bd0d !important;
        }
    
        &--grey {
            background: #2c3234 !important;
        }
    }

    .report__status {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;

        &__item {
            min-width: 100px;
            
            &:not(:last-of-type) {
                margin-bottom: 25px;
            }
        }
    }
</style>